import { useTranslation } from '@mypoz/i18n';
import { Icon } from '@mypoz/ui';

import { useOrderCatalog } from '@/features/orders/catalogContext.js';
import { buttonClass } from '@/lib/styles.js';

/**
 * Said when the order flow's reference data failed to load (MYP-87's retry requirement).
 *
 * That fetch carries the country list and the vendor's "orderable package" codes as well as the
 * channel dictionary, so a failure left the packages step empty and the address cascade blank
 * with nothing on screen to say why. One banner over the steps, with a Retry, covers all three.
 */
export function CatalogErrorBanner() {
  const { t } = useTranslation();
  const { status, reload } = useOrderCatalog();

  if (status !== 'error') return null;

  return (
    <div
      role="alert"
      className="mb-5 flex flex-col gap-3 rounded-md border border-danger/30 bg-danger/5 px-4 py-3 sm:flex-row sm:items-center"
    >
      <p className="flex-1 text-sm text-danger">{t('orders.channelScope.catalogError')}</p>
      <button type="button" onClick={reload} className={buttonClass('secondary')}>
        <Icon name="refresh" size={18} />
        {t('orders.channelScope.retry')}
      </button>
    </div>
  );
}
